/**
 * Yetishmayotgan tarjimalar — uz/ru/en sinxron.
 * Yangilash: node scripts/sync-i18n-keys.js
 */
export const translationPatches = {
  uz: {
    adminOmbor_open_measures_to_fill: 'Saqlashdan oldin «+ Qo\'shish» orqali o\'lchovlar bo\'limini oching va asosiy qoldiq hamda narxlarni kiriting.',
    adminOmbor_sale_lines_required: 'Kamida bitta qo\'shimcha o\'lchov yoki variant qo\'shing (narx bilan), yoki «Erkin narx»ni yoqing.',
    adminOmbor_add_variant_row: 'Variant qo\'shish',
    adminOmbor_nested_lines_title: 'Qo\'shimcha sotilish',
    adminOmbor_all_units_used: 'Barcha o\'lchovlar allaqachon qo\'shilgan. Mavjud kartada o\'lchovni o\'zgartiring yoki ortiqcha kartani o\'chiring.',
    adminOmbor_barcode_missing: 'Shtrix-kod mavjud emas',
    adminOmbor_kpi_expiry_clear: 'Filterni bekor qilish',
    adminOmbor_kpi_expiry_filter: 'Filtrlash',
    adminOmbor_kpi_expiry_active: '✓ Filtr faol — bekor qilish uchun bosing',
    adminOmbor_variant_select: 'Variant tanlang',
    adminOmbor_product_id_missing: 'Mahsulot identifikatori topilmadi. Qatorni yangilab qayta urinib ko‘ring.',
    adminOmbor_variant_required: 'Variant tanlash majburiy.',
    adminOmbor_sale_price_required_on_edit: 'Asosiy o\'lchov uchun sotilgan narx 0 dan katta bo\'lishi kerak.',
    adminOmbor_measure_card_title_primary: 'Asosiy o\'lchov',
    adminOmbor_tenant_ownerlar: 'Mijozlar (ega)',
    adminInventoryAudit_title: 'Inventarizatsiya audit',
    adminExpiryTracking_title: 'Muddati yaqin mahsulotlar',
    common_cancel: 'Bekor qilish',
    common_close: 'Yopish',
    common_edit: 'Tahrirlash',
    common_delete: 'O\'chirish',
    common_save_error: 'Saqlashda xatolik',
    adminLoading: 'Yuklanmoqda…',
    navHome: 'Bosh sahifa',
    loginModalPasswordHide: 'Parolni yashirish',
    loginModalPasswordShow: 'Parolni ko\'rsatish',
    roleSwitch_enter_cashier_pin: 'Kassirning PIN\'ini kiriting',
    adminOrder_convert_region_manager_required: 'Viloyat va viloyat menejerini tanlang.',
    adminOrder_subtitle_ega: 'Barcha buyurtmalar ro\'yxati. Mijoz, menejer, dispecher va holat bo\'yicha kuzatish.',
    adminNotif_subtitle_tenant_owner: 'Chat va tizim bildirishnomalari. Qo\'llab-quvvatlash javoblari shu yerda ham ko\'rinadi.',
    adminStat_filter_all_regions: 'Barcha viloyatlar',
    adminStat_netProfitMonth: 'Oylik sof foyda',
    adminStat_platform_overview: 'Platforma ko\'rsatkichlari',
    adminStat_digitalRevenue: 'Click / Payme',
    adminStat_analyst_overview: 'Analitika ko‘rinishi',
    adminStat_analyst_visitors: 'Tashriflar',
    adminStat_analyst_sessions: 'Sessiyalar',
    adminStat_analyst_top_channel: 'Asosiy kanal',
    adminStat_analyst_new_customers: 'Yangi mijozlar',
    adminStat_analyst_avg_session: 'O\'rtacha sessiya',
    adminStat_analyst_bounce: 'Bounce rate',
    adminStat_chartTitle_analyst: 'Haftalik tashriflar',
    adminCredits_repay_total_invalid: 'Jami yechim qoldiqdan oshib ketmasligi kerak.',
    adminCredits_manual_add: "Qo'lda nasiya qo'shish",
    adminCredits_manual_hint:
      'Chakana mijoz ism yoki telefon bo‘yicha qidiring. Topilmasa yangi mijoz yaratiladi.',
    adminCredits_manual_amount: 'Nasiya summasi (UZS)',
    adminCredits_manual_note: 'Izoh (ixtiyoriy)',
    adminCredits_manual_client_required: 'Ism va telefon kiriting',
    adminCredits_manual_amount_required: 'Summa 0 dan katta bo‘lishi kerak',
    adminCredits_manual_phone_invalid:
      'Telefon raqami noto‘g‘ri. Masalan: 90 123 45 67 yoki +998 90 123 45 67',
    retailClients_name: 'Ism',
    retailClients_phone: 'Telefon',
    adminPL_expense_product_volume_note: 'Mahsulot hajmi (ixtiyoriy)',
    adminPL_units_short: 'birlik',
    adminSettings_printer_app: 'Printer ilovasi',
    cashierKassa_quick_units: 'Tezkor sotuv birliklari',
    cashierKassa_cart_line_unit: 'O\'lchov',
    adminOmbor_bulk_intake_product_search: 'Mahsulot nomi, shtrix-kod yoki ID',
    adminOmbor_bulk_intake_product_no_results: 'Qidiruv bo‘yicha mahsulot topilmadi',
    cashierKassa_free_price_required: 'Erkin narxni kiriting (0 dan katta).',
    cashierKassa_out_of_stock: '«{name}» — omborda qolmagan.',
    cashierKassa_branch_mix_forbidden: 'Bitta savatchada turli filial tovarlarini aralashtirib bo‘lmaydi.',
    cashierKassa_test_receipt_success: 'Test chek muvaffaqiyatli yuborildi.',
    appNotice_confirm: 'Tushundim',
    api_error_product_value_exceeds: 'Tovar qiymati qolgan qarzdan oshib ketdi. Miqdorni kamaytiring.',
    api_error_insufficient_stock: 'Yetarli qoldiq yo‘q. Mavjud: {n}',
    api_error_zero_sale_value: 'Mahsulot sotuv narxi 0 — tovar bilan to‘lab bo‘lmaydi.',
    api_error_expense_already_paid: 'Xarajat allaqachon to‘liq to‘langan.',
    api_error_forbidden: 'Ruxsat yo‘q.',
    api_error_branch_inventory_mismatch: 'Mahsulot filiali mos kelmaydi.',
    api_error_invalid_qty: 'Noto‘g‘ri miqdor.',
    api_error_allocation_failed: 'To‘lovni taqsimlab bo‘lmadi.',
    api_error_tenant_not_found: 'Tashkilot topilmadi.',
    adminExpenses_product_search: 'Mahsulot qidirish…',
    adminExpenses_product_max_qty: 'Maksimal miqdor: {n}',
    adminExpenses_product_pick_hint: 'Ro‘yxatdan mahsulotni bosing',
    adminExpenses_stock_short: 'Qoldiq',
    common_ok: 'OK',
    adminPosAccess_error_plan: 'Joriy tarifda POS kabina ruxsati yo‘q. Tarifni 299 000 so‘m yoki yuqoriga yangilang.',
    adminPosAccess_error_limit: 'Tarif bo‘yicha POS ruxsati limiti to‘ldi.',
    cashierKassa_cart_open_sheet: 'Barcha qatorlarni tahrirlash',
    cashierKassa_cart_sheet_title: 'Savatchani tahrirlash',
    cashierKassa_cart_sheet_hint: 'Har bir qatorni ochib miqdor va narxni o‘zgartiring',
    cashierKassa_choose_variant_only: 'Variant tanlang',
    printer_status_connected: 'Printer: {name}',
    printer_status_not_connected: 'Printer: ulanmagan',
    printer_status_desktop_unavailable: 'Printer: desktop rejim yo\'q',
    barcode_printer_status_connected: 'Shtrix-kod: {name}',
    barcode_printer_status_not_connected: 'Shtrix-kod: ulanmagan',
    barcode_printer_status_desktop_unavailable: 'Shtrix-kod: desktop rejim yo\'q',
    printer_settings_title: 'Printer sozlamalari',
    printer_receipt_label: 'Chek printeri',
    printer_barcode_label: 'Shtrix-kod printeri',
    printer_auto_select: 'Avto tanlash',
    printers_detected: '{count} ta printer aniqlandi',
    printer_status_fetch_error: 'Printer holatini olib bo\'lmadi',
    adminBarcodeScan_title: 'Shtrix-kod skaner',
    adminBarcodeScan_hint: 'Shtrix-kodni ramka ichiga tuting',
    adminBarcodeScan_container_missing: 'Skaner konteyneri topilmadi',
    adminBarcodeScan_camera_error: 'Kamerani ochishda xatolik',
    printer_app_title: 'Printer ilovasi',
    printer_app_desc: 'Cheklar uchun mahalliy printer ilovasini yuklab oling. Bir marta o\'rnatib sozlang.',
    printer_app_download: 'Printer ilovasini yuklab olish',
    printer_app_download_error: 'Yuklab olishda xatolik',
    printer_app_hint: 'LocalPrintingBridge.exe — ilovani o‘rnatib, printer sozlang. Keyin cheklar avtomatik chiqadi.',
    qz_settings_title: 'QZ Tray — Printer sozlamalari',
    qz_connected: 'Ulangan',
    qz_disconnected: 'Ulanmagan',
    qz_connect: 'QZ Tray ga ulash',
    qz_disconnect: 'Uzish',
    qz_select_printer: 'Printer tanlash',
    qz_select_placeholder: '— Printer tanlang —',
    qz_test_print: 'Chop etish (sinov chek)',
    qz_connect_error: 'Ulanishda xatolik',
    qz_select_first: 'Avval printer tanlang',
    qz_test_success: 'Test chek muvaffaqiyatli chiqdi!',
    qz_print_error: 'Chop etishda xatolik',
    qz_hint: 'QZ Tray kompyuteringizda ishlab turishi kerak. qz.io dan yuklab oling. Tanlangan printer keyingi sessiyada eslab qolinadi.',
    cashierProducts_stock_in_title: 'Omborga qo\'shish',
    cashierProducts_fav_add: 'Tanlanganlarga qo\'shish',
    cashierProducts_fav_remove: 'Tanlanganlardan olib tashlash',
    cashierProducts_stock_in_product: 'Mahsulot',
    cashierProducts_stock_in_cost: 'Tannarx',
    cashierProducts_stock_in_measure: 'O\'lchov',
    adminMarketing_close: 'Yopish',
    adminMarketing_dismiss_notice: 'Bildirishnomani yopish',
    adminMarketing_dismiss_error: 'Xatoni yopish',
    adminMarketing_orders_loading: 'Yuklanmoqda…',
    adminMarketing_orders_empty_day: 'Tanlangan kun uchun online buyurtmalar topilmadi.',
    adminMarketing_branches_label: 'Filiallar',
    adminMarketing_orders_hint_owner: 'Kunlik ro‘yxat (tanlangan sana). Holat Telegram va bu yerda bir xil saqlanishi uchun backend bitta manbaga ulangan bo‘lishi kerak.',
    adminMarketing_owner_lead: 'Marketing: onlayn do‘kon (qisqa /{path}/… havolasi), buyurtmalar va Telegram.',
    adminMarketing_shop_url_label: 'Onlayn do‘kon manzili',
    adminMarketing_shop_hint_local: 'Mahalliy sinov: havola joriy origin orqali. Productionda asosiy domen uchun REACT_APP_SHOP_ROOT_DOMAIN=adde.app qo‘ying — kartochkada ham shu domen chiqadi.',
    adminMarketing_shop_qr_alt: '{name} do‘kon QR',
    adminMarketing_delivery: 'Dastafka',
    adminMarketing_delivery_on: 'Yoqilgan',
    adminMarketing_delivery_off: 'O‘chirilgan',
    adminMarketing_tg_group: 'Guruh',
    adminMarketing_telegram_group: 'Telegram guruh',
    adminMarketing_linked: 'Ulangan',
    adminMarketing_unlinked: 'Ulanmagan',
    adminMarketing_copy_url: 'Havolani nusxalash',
    adminMarketing_configure: 'Sozlash',
    adminMarketing_orders_title_owner: 'Online buyurtmalar',
    adminMarketing_filter_date: 'Sana',
    adminMarketing_filter_branch: 'Filial',
    adminMarketing_all_branches: 'Barcha filiallar',
    adminMarketing_status_new: 'Yangi',
    adminMarketing_status_confirmed: 'Qabul qilindi',
    adminMarketing_status_cancelled: 'Rad etildi',
    adminMarketing_total_sales: 'Jami savdo',
    adminMarketing_net_profit: 'Sof foyda',
    adminMarketing_address: 'Manzil',
    adminMarketing_region: 'Hudud',
    adminMarketing_saving: 'Saqlanmoqda…',
    adminMarketing_btn_confirm: 'Qabul qilindi',
    adminMarketing_btn_reject: 'Rad etildi',
    adminMarketing_settings_title: 'Filial marketing sozlamalari',
    adminMarketing_subdomain_optional: 'Do‘kon subdomeni (ixtiyoriy)',
    adminMarketing_subdomain_path_optional: 'Do‘kon havolasi uchun qisqa nom (ixtiyoriy, /{path}/…)',
    adminMarketing_subdomain_ph: 'masalan: dilshod-market',
    adminMarketing_subdomain_path_ph: 'masalan: chust (bo‘sh — id yoki slug)',
    adminMarketing_subdomain_invalid: 'Faqat kichik harf, raqam va tire; boshida/oxirida tire bo‘lmasin.',
    adminMarketing_toggle_delivery: 'Dastafka xizmatini yoqish/o‘chirish',
    adminMarketing_tg_connect: 'Telegramda guruhga ulash',
    adminMarketing_tg_connect_hint: 'Tugmani bosing — Telegram ochiladi, guruhni tanlaysiz, bot guruhga qo‘shiladi. Botni alohida tanlash yoki chat ochish shart emas. Bog‘lanish serverda yangilanadi (webhook yoqilgach).',
    adminMarketing_tg_qr_scan: 'Yoki QR kodni telefon kamerasi bilan skanerlang',
    adminMarketing_tg_qr_alt: 'Telegram guruhga qo‘shish',
    adminMarketing_status: 'Holat',
    adminMarketing_tg_linked_status: 'Ulangan — {title}',
    adminMarketing_tg_pending_status: 'Kutilmoqda (bot guruhga qo‘shilgach yangilanadi)',
    adminMarketing_group_fallback: 'guruh',
    adminMarketing_save: 'Saqlash',
    adminMarketing_save_failed: 'Saqlanmadi',
    adminMarketing_order_status_failed: 'Buyurtma holatini yangilab bo‘lmadi. Iltimos, qayta urinib ko‘ring.',
    adminMarketing_new_orders_count: '{count} ta yangi online buyurtma keldi ({time}).',
    adminMarketing_new_order_single: 'Yangi online buyurtma: #{number}',
    adminMarketing_payment_cash: 'Naqd',
    adminMarketing_payment_card: 'Karta',
    adminMarketing_payment_transfer: 'Bank o\'tkazma',
    branchShop_total: 'Jami',
    branchShop_client_name: 'Mijoz ismi',
    branchShop_client_name_ph: 'Ism',
    branchShop_phone: 'Telefon',
    branchShop_phone_aria: 'Mobil raqam, 9 ta raqam',
    branchShop_delivery_method: 'Qabul qilish usuli',
    branchShop_pickup: 'Olib ketish',
    branchShop_delivery: 'Yetkazib berish',
    branchShop_region: 'Viloyat',
    branchShop_region_select: 'Viloyat tanlang',
    branchShop_district: 'Tuman',
    branchShop_district_select_first: 'Avval viloyat tanlang',
    branchShop_district_select: 'Tuman tanlang',
    branchShop_address: 'Manzil',
    branchShop_address_ph: 'Yetkazib berish manzili',
    branchShop_verify_code_title: 'Tasdiqlash kodi',
    branchShop_verify_code_desc: 'Quyidagi kod SMS xabaringizda ham bor (test / dev javobi).',
    branchShop_test_badge: 'Test',
    branchShop_copied: 'Nusxalandi',
    branchShop_copy_code: 'Nusxa olish',
    branchShop_sms_code: 'SMS kodi',
    branchShop_resend_in: 'Qayta yuborish',
    branchShop_sms_sending: 'SMS yuborilmoqda…',
    branchShop_verify_phone: 'Raqamni tasdiqlash',
    branchShop_submitting: 'Yuborilmoqda…',
    branchShop_send_sms: 'SMS yuborish',
    branchShop_place_order: 'Buyurtma berish',
    branchShop_phone_verified: '✓ Telefon tasdiqlandi. Buyurtmani yuborishingiz mumkin.',
    branchShop_default_title: 'Filial do‘koni',
    branchShop_subtitle: 'Online buyurtma — mahsulotni tanlang va yuboring.',
    branchShop_cart_aria: 'Savat',
    branchShop_loading: 'Yuklanmoqda…',
    branchShop_search_label: 'Mahsulot qidirish',
    branchShop_search_ph: 'Nom, markirovka, marketing sarlavha, kalit so‘zlar…',
    branchShop_no_products: 'Hozircha mahsulotlar yo‘q.',
    branchShop_no_search_results: 'Qidiruv bo‘yicha mahsulot topilmadi.',
    branchShop_no_image: 'Rasm yo‘q',
    branchShop_add_to_cart: 'Savatga qo‘shish',
    branchShop_cart_title: 'Savat',
    branchShop_cart_empty: 'Hozircha bo‘sh.',
    branchShop_qty_aria: 'Miqdor',
    branchShop_qty_max: 'Maks. {n} ta',
    branchShop_remove_from_cart: 'Mahsulotni savatdan olib tashlash',
    branchShop_close: 'Yopish',
    branchShop_variant_hint: 'O‘lchov yoki variantni tanlang',
    branchShop_unit_factor_hint: 'Ichida {n} ta dona',
    branchShop_variant_default: 'Variant',
    branchShop_sms_not_sent: 'Avval SMS yuboring.',
    branchShop_verify_failed: 'Tasdiqlash muvaffaqiyatsiz.',
    branchShop_code_verify_failed: 'Kod tasdiqlanmadi.',
    branchShop_sms_not_verified_submit: 'SMS tasdiqlanmagan.',
    branchShop_branch_unknown: 'Filial aniqlanmadi. Sahifani yangilab, qayta urinib ko‘ring.',
    branchShop_cart_invalid: 'Savat bo‘sh yoki miqdorlar noto‘g‘ri.',
    branchShop_order_success: 'Buyurtma qabul qilindi. Ombor qoldig\'i onlayn buyurtma kassir/Telegram orqali qabul qilinganda kamayadi. Tez orada bog\'lanamiz.',
    branchShop_insufficient_stock: 'Mahsulot qoldigi yetarli emas. Savatdagi miqdorni kamaytiring yoki sahifani yangilang.',
    branchShop_order_failed: 'Buyurtma yuborilmadi. Iltimos qayta urinib ko\'ring.',
    branchShop_sms_failed: 'SMS yuborilmadi.',
    branchShop_branch_default: 'Filial',
    branchShop_err_phone_invalid: 'Telefon raqami noto\'g\'ri.',
    branchShop_err_sms_code_invalid: 'SMS kodi noto\'g\'ri.',
    branchShop_err_sms_code_expired: 'SMS kodi eskirgan, qayta yuboring.',
    branchShop_err_sms_not_verified: 'Telefon hali tasdiqlanmagan.',
    branchShop_err_verification_not_found: 'Tasdiqlash sessiyasi topilmadi, qayta SMS yuboring.',
    branchShop_err_branch_id_invalid: 'Filial ID aniqlanmadi. Sahifani yangilang yoki to\'g\'ri do\'kon havolasidan kiring.',
    adminOmbor_barcode_print_failed: 'Shtrix-kodni chop etib bo\'lmadi',
    adminOmbor_desktop_printer_api_missing: 'Desktop printer API topilmadi. Ilovani qayta ochib, printer tanlovini tekshiring.',
  },
  ru: {
    region_toshkent: 'Ташкент',
    region_samarqand: 'Самарканд',
    region_fargona: 'Фергана',
    region_andijon: 'Андижан',
    region_namangan: 'Наманган',
    region_buxoro: 'Бухара',
    region_qashqadaryo: 'Кашкадарья',
    region_surxondaryo: 'Сурхандарья',
    region_navoiy: 'Навои',
    region_jizzax: 'Джизак',
    region_sirdaryo: 'Сырдарья',
    region_qoraqalpoq: 'Каракалпакстан',
    region_toshkent_shahri: 'город Ташкент',
    region_toshkent_viloyati: 'Ташкентская область',
    region_xorazm: 'Хорезм',
    region_qoraqalpokiston: 'Каракалпакстан',
    adminProfile_name_label: 'Имя',
    adminProfile_name_placeholder: 'Имя и фамилия',
    adminProfile_name_required: 'Введите имя',
    adminStat_branch_rating: 'Рейтинг филиалов',
    adminStat_branch_rank_label: 'Рейтинг',
    month_jul: 'Июль',
    month_aug: 'Август',
    month_sep: 'Сентябрь',
    month_oct: 'Октябрь',
    month_nov: 'Ноябрь',
    month_dec: 'Декабрь',
    cashierKassa_cart_tap_edit_weighted: 'Нажмите: изменить количество, цену за единицу или сумму строки',
    cashierKassa_cart_edit_title: 'Редактирование позиции (кг / м)',
    cashierKassa_cart_edit_hint: 'Количество, цена за единицу или сумма — при изменении одного остальные пересчитываются автоматически.',
    cashierKassa_cart_edit_qty: 'Количество',
    cashierKassa_cart_edit_unit_price: 'Цена за единицу (UZS)',
    cashierKassa_cart_edit_line_total: 'Итого (UZS)',
    cashierKassa_cart_edit_apply: 'Сохранить',
    cashierKassa_cart_edit_invalid_qty: 'Неверное или слишком маленькое количество.',
    cashierProducts_additional_unit_title: 'Дополнительная единица',
    cashierProducts_variant_title: 'Вариант',
    adminTrans_filter_all_branches: 'Все филиалы',
    adminTrans_filter_all_cashiers: 'Все кассиры',
    adminTrans_view_receipt: 'Просмотр чека',
    adminTrans_receipt_title: 'Счёт-фактура',
    adminTrans_receipt_branch: 'Название филиала',
    adminTrans_receipt_datetime: 'Дата и время',
    adminTrans_receipt_cashier: 'Кассир (ФИО)',
    adminTrans_receipt_invoice_no: 'Номер счёта',
    adminTrans_receipt_products: 'Товары',
    adminTrans_receipt_qty: 'Количество',
    adminTrans_receipt_price: 'Цена (сум)',
    adminTrans_receipt_sum: 'Сумма (сум)',
    adminTrans_receipt_items_count: 'Количество позиций',
    adminTrans_receipt_total_qty: 'Общее количество',
    adminTrans_receipt_discount: 'Скидка',
    adminTrans_receipt_vat: 'НДС',
    adminTrans_receipt_grand_total: 'Итоговая сумма',
    adminTrans_receipt_subtotal: 'Промежуточный итог',
    adminTrans_receipt_client_number: 'Номер розничного клиента',
    adminTrans_receipt_print: 'Печать',
    adminTrans_receipt_telegram: 'Отправить в Telegram',
    adminTrans_receipt_telegram_sending: 'Отправка…',
    adminTrans_receipt_telegram_hint: 'Отправить PDF счёта в Telegram-бот клиента',
    adminTrans_receipt_telegram_not_linked: 'Клиент ещё не подключил телефон к розничному боту',
    adminTrans_receipt_telegram_ok: 'PDF счёта отправлен в Telegram',
    adminTrans_receipt_telegram_failed: 'Не удалось отправить через Telegram',
    adminTrans_receipt_load_error: 'Не удалось загрузить чек',
    adminTrans_receipt_unavailable: 'Чек недоступен',
    receiptBlock_retail_client: 'Розничный клиент',
    receiptPreview_retail_client: 'Розничный клиент',
    receiptSettings_text_placeholder_tin: 'Например: ИНН 307123456',
    receiptSettings_text_placeholder_legal_name: 'Например: юридическое название «ООО …»',
    receiptSettings_text_placeholder_header_work_hours: 'Например: 09:00 — 21:00',
    receiptSettings_text_placeholder_contacts: 'Телефон ответственного сотрудника филиала',
    adminTrans_payment_click: 'Click',
    adminTrans_payment_nasiya: 'Рассрочка',
    adminTrans_payment_refund: 'Возврат',
    adminTrans_retail_client: 'Розничный клиент',
    adminTrans_actions: 'Действие',
    adminTrans_refund_btn: 'Возврат',
    adminTrans_refund_modal_title: 'Возврат товаров',
    adminTrans_refund_modal_lead: 'Укажите возвращаемое количество по каждой строке (целое число).',
    adminTrans_refund_max: 'Макс.',
    adminTrans_refund_qty: 'Количество',
    adminTrans_refund_ok: 'Возврат успешно выполнен.',
    adminTrans_refund_qty_required: 'Укажите количество хотя бы в одной строке.',
    adminTrans_refund_from_order: 'Основная продажа',
    adminTrans_refund_confirm: 'Оформить возврат',
    adminTrans_search_placeholder: 'Товар, штрихкод, розничный клиент (имя, телефон), цена…',
    adminStat_refund_lines_title: 'Подробно: чек, время, товар, количество, сумма',
    adminTrans_product_name: 'Название товара',
    adminTrans_barcode: 'Штрихкод',
    adminExpenses_paid_by: 'Внёс',
    adminExpenses_payment_history: 'История платежей',
    adminExpenses_stock_short: 'Остаток',
    adminExpenses_product_search: 'Поиск товара…',
    adminExpenses_product_max_qty: 'Максимальное количество: {n}',
    adminExpenses_product_pick_hint: 'Нажмите товар в списке',
    adminOmbor_subtitle: 'Товары всех клиентов — остатки и проданное количество.',
    adminOmbor_add_product: 'Добавить товар',
    adminOmbor_mijozlar: 'Клиенты',
    adminOmbor_mahsulotlar: 'Виды товаров',
    adminOmbor_jami_qoldiq: 'Общий остаток',
    adminOmbor_jami_sotilgan: 'Всего продано',
    adminOmbor_jami_qoldiq_summasi: 'Сумма остатка',
    adminOmbor_search_placeholder: 'Поиск по клиенту, товару или региону…',
    adminOmbor_refresh: 'Обновить',
    adminOmbor_mijoz: 'Клиент',
    adminOmbor_viloyat: 'Регион',
    adminOmbor_mahsulot: 'Товар',
    adminOmbor_col_image: 'Фото',
    adminOmbor_product_image: 'Фото товара (необязательно)',
    adminOmbor_product_id: 'ID',
    adminOmbor_qoldiq: 'Остаток',
    adminOmbor_qoldiq_value: 'Сумма остатка',
    adminOmbor_sotilgan: 'Продано',
    adminOmbor_empty: 'Данные не найдены.',
    adminOmbor_modal_add: 'Новый товар',
    adminOmbor_modal_edit: 'Редактировать товар',
    adminOmbor_name_placeholder: 'Название товара',
    adminOmbor_quantity: 'Количество',
    adminOmbor_barcode_auto: 'если пусто — создаётся автоматически',
    adminOmbor_measures_section: 'Единицы измерения',
    adminOmbor_measure_card_title: 'Единица',
    adminOmbor_primary_unit_title: 'ОСНОВНАЯ ЕДИНИЦА',
    adminOmbor_extra_sale_header: 'ДОПОЛНИТЕЛЬНАЯ ПРОДАЖА',
    adminOmbor_add_short: 'Добавить',
    adminOmbor_variant_delete_disabled: 'Должен остаться хотя бы один вариант',
    adminOmbor_confirm_delete: 'Удалить товар',
    adminOmbor_confirm_delete_text: 'Вы действительно хотите удалить товар',
    adminOmbor_view_title: 'Информация о товаре',
    adminOmbor_detail_info: 'Основная информация',
    adminOmbor_detail_stats: 'Статистика продаж',
    adminOmbor_sold_daily_avg: 'Средние продажи в день',
    adminOmbor_sold_weekly_avg: 'Средние продажи в неделю',
    adminOmbor_sold_monthly_avg: 'Средние продажи в месяц',
    adminOmbor_total_revenue: 'Общая выручка',
    adminOmbor_total_cost: 'Себестоимость',
    adminOmbor_net_profit: 'Чистая прибыль',
    adminOmbor_filter_all_branches: 'Все филиалы',
    adminOmbor_sales_by_day: 'Продажи за месяц (по дням)',
    adminOmbor_chart_no_data: 'Нет данных за этот месяц',
    adminOmbor_chart_legend: 'Дни 1–31, столбец — проданное количество',
    adminOmbor_search_inv_placeholder: 'Поиск по названию, цене, штрихкоду',
    adminOmbor_kpi_product_types: 'Общее число видов товаров',
    adminOmbor_kpi_expiry_critical: 'Срок годности менее 3 дней',
    adminOmbor_kpi_expiry_hint: 'Нажмите для фильтра / снова — сброс',
    adminOmbor_expiry_date: 'Срок годности',
    adminOmbor_expiry_days_left: 'дн. осталось',
    adminOmbor_expiry_passed: 'Срок истёк',
    adminOmbor_select_branch_for_table: 'Выберите филиал для просмотра таблицы',
    product_sale_price_per_unit_hint: 'Цена за 1 кг или 1 м',
    adminOmbor_open_measures_to_fill: 'Перед сохранением откройте раздел единиц через «+ Добавить» и укажите основной остаток и цены.',
    adminOmbor_sale_lines_required: 'Добавьте хотя бы одну дополнительную единицу или вариант (с ценой) или включите «Свободная цена».',
    adminOmbor_add_variant_row: 'Добавить вариант',
    adminOmbor_nested_lines_title: 'Дополнительная продажа',
    adminOmbor_all_units_used: 'Все единицы уже добавлены. Измените единицу в существующей карточке или удалите лишнюю.',
    adminOmbor_barcode_missing: 'Штрих-код отсутствует',
    adminOmbor_kpi_expiry_clear: 'Сбросить фильтр',
    adminOmbor_kpi_expiry_filter: 'Фильтровать',
    adminOmbor_kpi_expiry_active: '✓ Фильтр активен — нажмите для сброса',
    adminOmbor_variant_select: 'Выберите вариант',
    adminOmbor_product_id_missing: 'Идентификатор товара не найден. Обновите строку и попробуйте снова.',
    adminOmbor_variant_required: 'Необходимо выбрать вариант.',
    adminOmbor_sale_price_required_on_edit: 'Цена продажи основной единицы должна быть больше 0.',
    adminOmbor_measure_card_title_primary: 'Основная единица',
    adminOmbor_tenant_ownerlar: 'Клиенты (владельцы)',
    adminInventoryAudit_title: 'Аудит инвентаризации',
    adminExpiryTracking_title: 'Отслеживание срока годности',
    common_cancel: 'Отмена',
    common_close: 'Закрыть',
    common_edit: 'Редактировать',
    common_delete: 'Удалить',
    common_save_error: 'Ошибка сохранения',
    adminLoading: 'Загрузка…',
    navHome: 'Главная',
    loginModalPasswordHide: 'Скрыть пароль',
    loginModalPasswordShow: 'Показать пароль',
    roleSwitch_enter_cashier_pin: 'Введите PIN кассира',
    adminOrder_convert_region_manager_required: 'Выберите регион и регионального менеджера.',
    adminOrder_subtitle_ega: 'Список всех заказов. Контроль по клиенту, менеджеру, диспетчеру и статусу.',
    adminNotif_subtitle_tenant_owner: 'Чат и системные уведомления. Ответы поддержки также отображаются здесь.',
    adminStat_filter_all_regions: 'Все регионы',
    adminStat_netProfitMonth: 'Чистая прибыль за месяц',
    adminStat_platform_overview: 'Показатели платформы',
    adminStat_digitalRevenue: 'Click / Payme',
    adminStat_analyst_overview: 'Обзор аналитики',
    adminStat_analyst_visitors: 'Посещения',
    adminStat_analyst_sessions: 'Сессии',
    adminStat_analyst_top_channel: 'Основной канал',
    adminStat_analyst_new_customers: 'Новые клиенты',
    adminStat_analyst_avg_session: 'Средняя сессия',
    adminStat_analyst_bounce: 'Bounce rate',
    adminStat_chartTitle_analyst: 'Визиты по неделям',
    adminCredits_repay_total_invalid: 'Общая сумма списания не должна превышать остаток.',
    adminCredits_manual_add: 'Добавить рассрочку вручную',
    adminCredits_manual_hint:
      'Найдите розничного клиента по имени или телефону. Если не найден — будет создан новый.',
    adminCredits_manual_amount: 'Сумма рассрочки (UZS)',
    adminCredits_manual_note: 'Примечание (необязательно)',
    adminCredits_manual_client_required: 'Введите имя и телефон',
    adminCredits_manual_amount_required: 'Сумма должна быть больше 0',
    adminCredits_manual_phone_invalid:
      'Неверный номер телефона. Например: 90 123 45 67 или +998 90 123 45 67',
    retailClients_name: 'Имя',
    retailClients_phone: 'Телефон',
    adminPL_expense_product_volume_note: 'Объём товара (необязательно)',
    adminPL_units_short: 'ед.',
    adminSettings_printer_app: 'Приложение для принтера',
    cashierKassa_quick_units: 'Быстрые единицы продажи',
    cashierKassa_cart_line_unit: 'Единица',
    adminOmbor_bulk_intake_product_search: 'Название, штрих-код или ID',
    adminOmbor_bulk_intake_product_no_results: 'По запросу товары не найдены',
    cashierKassa_free_price_required: 'Введите цену больше 0 для свободной цены.',
    cashierKassa_out_of_stock: '«{name}» — на складе нет остатка.',
    cashierKassa_branch_mix_forbidden: 'Нельзя смешивать товары разных филиалов в одной корзине.',
    cashierKassa_test_receipt_success: 'Тестовый чек успешно отправлен.',
    appNotice_confirm: 'Понятно',
    common_ok: 'OK',
    adminPosAccess_error_plan: 'На текущем тарифе POS-доступ недоступен. Обновите тариф от 299 000 сум.',
    adminPosAccess_error_limit: 'Достигнут лимит POS-доступов по тарифу.',
    cashierKassa_cart_open_sheet: 'Редактировать все строки',
    cashierKassa_cart_sheet_title: 'Редактирование корзины',
    cashierKassa_cart_sheet_hint: 'Откройте каждую строку и измените количество и цену',
    cashierKassa_choose_variant_only: 'Выберите вариант',
    printer_status_connected: 'Принтер: {name}',
    printer_status_not_connected: 'Принтер: не подключён',
    printer_status_desktop_unavailable: 'Принтер: режим desktop недоступен',
    barcode_printer_status_connected: 'Штрих-код: {name}',
    barcode_printer_status_not_connected: 'Штрих-код: не подключён',
    barcode_printer_status_desktop_unavailable: 'Штрих-код: режим desktop недоступен',
    printer_settings_title: 'Настройки принтера',
    printer_receipt_label: 'Чековый принтер',
    printer_barcode_label: 'Принтер штрих-кодов',
    printer_auto_select: 'Автовыбор',
    printers_detected: 'Обнаружено принтеров: {count}',
    printer_status_fetch_error: 'Не удалось получить статус принтера',
    adminBarcodeScan_title: 'Сканер штрих-кода',
    adminBarcodeScan_hint: 'Держите штрих-код в рамке',
    adminBarcodeScan_container_missing: 'Контейнер сканера не найден',
    adminBarcodeScan_camera_error: 'Ошибка открытия камеры',
    printer_app_title: 'Приложение для принтера',
    printer_app_desc: 'Скачайте локальное приложение для печати чеков. Установите и настройте один раз.',
    printer_app_download: 'Скачать приложение принтера',
    printer_app_download_error: 'Ошибка загрузки',
    printer_app_hint: 'LocalPrintingBridge.exe — установите приложение и настройте принтер. Чеки будут печататься автоматически.',
    qz_settings_title: 'QZ Tray — настройки принтера',
    qz_connected: 'Подключён',
    qz_disconnected: 'Не подключён',
    qz_connect: 'Подключиться к QZ Tray',
    qz_disconnect: 'Отключить',
    qz_select_printer: 'Выбор принтера',
    qz_select_placeholder: '— Выберите принтер —',
    qz_test_print: 'Печать (тестовый чек)',
    qz_connect_error: 'Ошибка подключения',
    qz_select_first: 'Сначала выберите принтер',
    qz_test_success: 'Тестовый чек успешно напечатан!',
    qz_print_error: 'Ошибка печати',
    qz_hint: 'QZ Tray должен работать на вашем компьютере. Скачайте с qz.io. Выбранный принтер сохранится для следующей сессии.',
    cashierProducts_stock_in_title: 'Добавить на склад',
    cashierProducts_fav_add: 'Добавить в избранное',
    cashierProducts_fav_remove: 'Убрать из избранного',
    cashierProducts_stock_in_product: 'Товар',
    cashierProducts_stock_in_cost: 'Себестоимость',
    cashierProducts_stock_in_measure: 'Единица',
    adminMarketing_close: 'Закрыть',
    adminMarketing_dismiss_notice: 'Закрыть уведомление',
    adminMarketing_dismiss_error: 'Закрыть ошибку',
    adminMarketing_orders_loading: 'Загрузка…',
    adminMarketing_orders_empty_day: 'Онлайн-заказы за выбранный день не найдены.',
    adminMarketing_branches_label: 'Филиалы',
    adminMarketing_orders_hint_owner: 'Ежедневный список (выбранная дата). Бэкенд должен быть подключён к одному источнику, чтобы статус совпадал в Telegram и здесь.',
    adminOmbor_barcode_print_failed: 'Не удалось напечатать штрих-код',
    adminOmbor_desktop_printer_api_missing: 'API desktop-принтера не найден. Перезапустите приложение и проверьте выбор принтера.',
    adminMarketing_owner_lead: 'Маркетинг: онлайн-магазин (короткая ссылка /{path}/…), заказы и Telegram.',
    adminMarketing_shop_url_label: 'Адрес онлайн-магазина',
    adminMarketing_shop_hint_local: 'Локальная проверка: ссылка через текущий origin. В production укажите REACT_APP_SHOP_ROOT_DOMAIN=adde.app — на карточке будет тот же домен.',
    adminMarketing_shop_qr_alt: 'QR магазина {name}',
    adminMarketing_delivery: 'Доставка',
    adminMarketing_delivery_on: 'Включена',
    adminMarketing_delivery_off: 'Выключена',
    adminMarketing_tg_group: 'Группа',
    adminMarketing_telegram_group: 'Telegram-группа',
    adminMarketing_linked: 'Подключено',
    adminMarketing_unlinked: 'Не подключено',
    adminMarketing_copy_url: 'Копировать ссылку',
    adminMarketing_configure: 'Настроить',
    adminMarketing_orders_title_owner: 'Онлайн-заказы',
    adminMarketing_filter_date: 'Дата',
    adminMarketing_filter_branch: 'Филиал',
    adminMarketing_all_branches: 'Все филиалы',
    adminMarketing_status_new: 'Новый',
    adminMarketing_status_confirmed: 'Принят',
    adminMarketing_status_cancelled: 'Отклонён',
    adminMarketing_total_sales: 'Общая продажа',
    adminMarketing_net_profit: 'Чистая прибыль',
    adminMarketing_address: 'Адрес',
    adminMarketing_region: 'Регион',
    adminMarketing_saving: 'Сохранение…',
    adminMarketing_btn_confirm: 'Принять',
    adminMarketing_btn_reject: 'Отклонить',
    adminMarketing_settings_title: 'Настройки маркетинга филиала',
    adminMarketing_subdomain_optional: 'Поддомен магазина (необязательно)',
    adminMarketing_subdomain_path_optional: 'Короткое имя ссылки магазина (необяз., /{path}/…)',
    adminMarketing_subdomain_ph: 'например: dilshod-market',
    adminMarketing_subdomain_path_ph: 'например: chust (пусто — id или slug)',
    adminMarketing_subdomain_invalid: 'Только строчные буквы, цифры и дефис; дефис не в начале и не в конце.',
    adminMarketing_toggle_delivery: 'Включить/выключить доставку',
    adminMarketing_tg_connect: 'Подключить группу в Telegram',
    adminMarketing_tg_connect_hint: 'Нажмите — откроется Telegram, выберите группу, бот будет добавлен. Отдельно выбирать бота или чат не нужно. Связь обновится на сервере (после webhook).',
    adminMarketing_tg_qr_scan: 'Или отсканируйте QR камерой телефона',
    adminMarketing_tg_qr_alt: 'Добавить в Telegram-группу',
    adminMarketing_status: 'Статус',
    adminMarketing_tg_linked_status: 'Подключено — {title}',
    adminMarketing_tg_pending_status: 'Ожидание (обновится после добавления бота в группу)',
    adminMarketing_group_fallback: 'группа',
    adminMarketing_save: 'Сохранить',
    adminMarketing_save_failed: 'Не удалось сохранить',
    adminMarketing_order_status_failed: 'Не удалось обновить статус заказа. Попробуйте снова.',
    adminMarketing_new_orders_count: 'Поступило {count} новых онлайн-заказов ({time}).',
    adminMarketing_new_order_single: 'Новый онлайн-заказ: #{number}',
    adminMarketing_payment_cash: 'Наличные',
    adminMarketing_payment_card: 'Карта',
    adminMarketing_payment_transfer: 'Банковский перевод',
    branchShop_total: 'Итого',
    branchShop_client_name: 'Имя клиента',
    branchShop_client_name_ph: 'Имя',
    branchShop_phone: 'Телефон',
    branchShop_phone_aria: 'Мобильный номер, 9 цифр',
    branchShop_delivery_method: 'Способ получения',
    branchShop_pickup: 'Самовывоз',
    branchShop_delivery: 'Доставка',
    branchShop_region: 'Область',
    branchShop_region_select: 'Выберите область',
    branchShop_district: 'Район',
    branchShop_district_select_first: 'Сначала выберите область',
    branchShop_district_select: 'Выберите район',
    branchShop_address: 'Адрес',
    branchShop_address_ph: 'Адрес доставки',
    branchShop_verify_code_title: 'Код подтверждения',
    branchShop_verify_code_desc: 'Этот код также в SMS (ответ test / dev).',
    branchShop_test_badge: 'Тест',
    branchShop_copied: 'Скопировано',
    branchShop_copy_code: 'Копировать',
    branchShop_sms_code: 'SMS-код',
    branchShop_resend_in: 'Повторная отправка',
    branchShop_sms_sending: 'Отправка SMS…',
    branchShop_verify_phone: 'Подтвердить номер',
    branchShop_submitting: 'Отправка…',
    branchShop_send_sms: 'Отправить SMS',
    branchShop_place_order: 'Оформить заказ',
    branchShop_phone_verified: '✓ Телефон подтверждён. Можно отправить заказ.',
    branchShop_default_title: 'Магазин филиала',
    branchShop_subtitle: 'Онлайн-заказ — выберите товар и отправьте.',
    branchShop_cart_aria: 'Корзина',
    branchShop_loading: 'Загрузка…',
    branchShop_search_label: 'Поиск товара',
    branchShop_search_ph: 'Название, маркировка, маркетинговый заголовок, ключевые слова…',
    branchShop_no_products: 'Пока нет товаров.',
    branchShop_no_search_results: 'По запросу товары не найдены.',
    branchShop_no_image: 'Нет фото',
    branchShop_add_to_cart: 'В корзину',
    branchShop_cart_title: 'Корзина',
    branchShop_cart_empty: 'Пока пусто.',
    branchShop_qty_aria: 'Количество',
    branchShop_qty_max: 'Макс. {n} шт.',
    branchShop_remove_from_cart: 'Удалить из корзины',
    branchShop_close: 'Закрыть',
    branchShop_variant_hint: 'Выберите размер или вариант',
    branchShop_unit_factor_hint: 'Внутри {n} шт.',
    branchShop_variant_default: 'Вариант',
    branchShop_sms_not_sent: 'Сначала отправьте SMS.',
    branchShop_verify_failed: 'Подтверждение не удалось.',
    branchShop_code_verify_failed: 'Код не подтверждён.',
    branchShop_sms_not_verified_submit: 'SMS не подтверждён.',
    branchShop_branch_unknown: 'Филиал не определён. Обновите страницу и попробуйте снова.',
    branchShop_cart_invalid: 'Корзина пуста или неверные количества.',
    branchShop_order_success: 'Заказ принят. Остаток на складе уменьшится после подтверждения кассиром/Telegram. Мы скоро свяжемся.',
    branchShop_insufficient_stock: 'Недостаточно остатка. Уменьшите количество или обновите страницу.',
    branchShop_order_failed: 'Не удалось отправить заказ. Попробуйте снова.',
    branchShop_sms_failed: 'SMS не отправлено.',
    branchShop_branch_default: 'Филиал',
    branchShop_err_phone_invalid: 'Неверный номер телефона.',
    branchShop_err_sms_code_invalid: 'Неверный SMS-код.',
    branchShop_err_sms_code_expired: 'SMS-код истёк, отправьте снова.',
    branchShop_err_sms_not_verified: 'Телефон ещё не подтверждён.',
    branchShop_err_verification_not_found: 'Сессия подтверждения не найдена, отправьте SMS снова.',
    branchShop_err_branch_id_invalid: 'ID филиала не определён. Обновите страницу или откройте правильную ссылку магазина.',
  },
  en: {
    region_toshkent: 'Tashkent',
    region_samarqand: 'Samarkand',
    region_fargona: 'Fergana',
    region_andijon: 'Andijan',
    region_namangan: 'Namangan',
    region_buxoro: 'Bukhara',
    region_qashqadaryo: 'Kashkadarya',
    region_surxondaryo: 'Surkhandarya',
    region_navoiy: 'Navoi',
    region_jizzax: 'Jizzakh',
    region_sirdaryo: 'Sirdarya',
    region_qoraqalpoq: 'Karakalpakstan',
    region_toshkent_shahri: 'Tashkent city',
    region_toshkent_viloyati: 'Tashkent region',
    region_xorazm: 'Khorezm',
    region_qoraqalpokiston: 'Karakalpakstan',
    adminProfile_name_label: 'Name',
    adminProfile_name_placeholder: 'Full name',
    adminProfile_name_required: 'Enter your name',
    adminStat_branch_rating: 'Branch rating',
    adminStat_branch_rank_label: 'Rank',
    month_jul: 'July',
    month_aug: 'August',
    month_sep: 'September',
    month_oct: 'October',
    month_nov: 'November',
    month_dec: 'December',
    adminBranch_tenant: 'Client (company) and number',
    adminBranch_region: 'Region',
    adminBranch_region_placeholder: 'Select region',
    adminBranch_tenant_placeholder: 'Select client (company)',
    adminBranch_view: 'View branch',
    adminBranch_view_title: 'Branch details',
    adminBranch_detail_info: 'Basic information',
    adminBranch_detail_stats: 'Sales statistics',
    adminBranch_detail_cashiers: 'Branch cashiers',
    adminBranch_detail_warehouse: 'Warehouse status',
    adminBranch_stat_orders_month: 'Orders this month',
    adminBranch_stat_revenue_month: 'Revenue this month',
    adminBranch_stat_revenue_total: 'Total revenue',
    adminBranch_stat_last_order: 'Last order time',
    adminBranch_cashier_name: 'Cashier',
    adminBranch_cashier_phone: 'Phone',
    adminBranch_cashier_status: 'Status',
    adminBranch_cashier_orders_month: 'Orders this month',
    adminBranch_cashier_revenue_month: 'Revenue this month',
    adminBranch_cashier_last_shift: 'Last shift',
    adminBranch_warehouse_products: 'Product count',
    adminBranch_warehouse_stock: 'Total stock',
    adminBranch_warehouse_stock_value: 'Stock value',
    cashierKassa_cart_tap_edit_weighted: 'Tap to edit quantity, unit price, or line total',
    cashierKassa_cart_edit_title: 'Edit line item (kg / m)',
    cashierKassa_cart_edit_hint: 'Quantity, unit price, or total — changing one recalculates the others automatically.',
    cashierKassa_cart_edit_qty: 'Quantity',
    cashierKassa_cart_edit_unit_price: 'Unit price (UZS)',
    cashierKassa_cart_edit_line_total: 'Line total (UZS)',
    cashierKassa_cart_edit_apply: 'Save',
    cashierKassa_cart_edit_invalid_qty: 'Invalid or too small quantity.',
    cashierProducts_additional_unit_title: 'Additional unit',
    cashierProducts_variant_title: 'Variant',
    adminTrans_filter_all_branches: 'All branches',
    adminTrans_filter_all_cashiers: 'All cashiers',
    adminTrans_view_receipt: 'View receipt',
    adminTrans_receipt_title: 'Invoice',
    adminTrans_receipt_branch: 'Branch name',
    adminTrans_receipt_datetime: 'Date and time',
    adminTrans_receipt_cashier: 'Cashier name',
    adminTrans_receipt_invoice_no: 'Invoice number',
    adminTrans_receipt_products: 'Products',
    adminTrans_receipt_qty: 'Quantity',
    adminTrans_receipt_price: 'Price (UZS)',
    adminTrans_receipt_sum: 'Amount (UZS)',
    adminTrans_receipt_items_count: 'Items count',
    adminTrans_receipt_total_qty: 'Total quantity',
    adminTrans_receipt_discount: 'Discount',
    adminTrans_receipt_vat: 'VAT',
    adminTrans_receipt_grand_total: 'Grand total',
    adminTrans_receipt_subtotal: 'Subtotal',
    adminTrans_receipt_client_number: 'Retail client number',
    adminTrans_receipt_print: 'Print',
    adminTrans_receipt_telegram: 'Send via Telegram',
    adminTrans_receipt_telegram_sending: 'Sending…',
    adminTrans_receipt_telegram_hint: 'Send invoice PDF to the client Telegram bot',
    adminTrans_receipt_telegram_not_linked: 'Client has not linked their phone to the retail bot yet',
    adminTrans_receipt_telegram_ok: 'Invoice PDF sent via Telegram',
    adminTrans_receipt_telegram_failed: 'Failed to send via Telegram',
    adminTrans_receipt_load_error: 'Failed to load receipt',
    adminTrans_receipt_unavailable: 'Receipt unavailable',
    receiptBlock_retail_client: 'Retail client',
    receiptPreview_retail_client: 'Retail client',
    receiptSettings_text_placeholder_tin: 'e.g. TIN 307123456',
    receiptSettings_text_placeholder_legal_name: 'e.g. legal name "LLC …"',
    receiptSettings_text_placeholder_header_work_hours: 'e.g. 09:00 — 21:00',
    receiptSettings_text_placeholder_contacts: 'Branch contact phone number',
    adminTrans_payment_click: 'Click',
    adminTrans_payment_nasiya: 'Installment',
    adminTrans_payment_refund: 'Refund',
    adminTrans_retail_client: 'Retail client',
    adminTrans_actions: 'Action',
    adminTrans_refund_btn: 'Refund',
    adminTrans_refund_modal_title: 'Return products',
    adminTrans_refund_modal_lead: 'Enter return quantity for each line (whole number).',
    adminTrans_refund_max: 'Max',
    adminTrans_refund_qty: 'Quantity',
    adminTrans_refund_ok: 'Refund completed successfully.',
    adminTrans_refund_qty_required: 'Enter quantity in at least one line.',
    adminTrans_refund_from_order: 'Original sale',
    adminTrans_refund_confirm: 'Process refund',
    adminTrans_search_placeholder: 'Product, barcode, retail client (name, phone), price…',
    adminStat_refund_lines_title: 'Details: receipt, time, product, qty, amount',
    adminTrans_product_name: 'Product name',
    adminTrans_barcode: 'Barcode',
    adminExpenses_paid_by: 'Entered by',
    adminExpenses_payment_history: 'Payment history',
    adminExpenses_stock_short: 'Stock',
    adminExpenses_product_search: 'Search products…',
    adminExpenses_product_max_qty: 'Maximum quantity: {n}',
    adminExpenses_product_pick_hint: 'Tap a product in the list',
    adminNav_credits: 'Installments',
    adminOmbor_subtitle: 'All clients\' products — stock and sold quantities.',
    adminOmbor_add_product: 'Add product',
    adminOmbor_mijozlar: 'Clients',
    adminOmbor_mahsulotlar: 'Product types',
    adminOmbor_jami_qoldiq: 'Total stock',
    adminOmbor_jami_sotilgan: 'Total sold',
    adminOmbor_jami_qoldiq_summasi: 'Stock value',
    adminOmbor_search_placeholder: 'Search by client, product, or region…',
    adminOmbor_refresh: 'Refresh',
    adminOmbor_mijoz: 'Client',
    adminOmbor_viloyat: 'Region',
    adminOmbor_mahsulot: 'Product',
    adminOmbor_col_image: 'Image',
    adminOmbor_product_image: 'Product image (optional)',
    adminOmbor_product_id: 'ID',
    adminOmbor_qoldiq: 'Stock',
    adminOmbor_qoldiq_value: 'Stock value',
    adminOmbor_sotilgan: 'Sold',
    adminOmbor_empty: 'No data found.',
    adminOmbor_modal_add: 'New product',
    adminOmbor_modal_edit: 'Edit product',
    adminOmbor_name_placeholder: 'Product name',
    adminOmbor_quantity: 'Quantity',
    adminOmbor_barcode_auto: 'auto-generated if left empty',
    adminOmbor_measures_section: 'Units of measure',
    adminOmbor_measure_card_title: 'Unit',
    adminOmbor_primary_unit_title: 'PRIMARY UNIT',
    adminOmbor_extra_sale_header: 'ADDITIONAL SALE UNITS',
    adminOmbor_add_short: 'Add',
    adminOmbor_variant_delete_disabled: 'At least one variant is required',
    adminOmbor_confirm_delete: 'Delete product',
    adminOmbor_confirm_delete_text: 'Are you sure you want to delete the product',
    adminOmbor_view_title: 'Product details',
    adminOmbor_detail_info: 'Basic information',
    adminOmbor_detail_stats: 'Sales statistics',
    adminOmbor_sold_daily_avg: 'Average daily sales',
    adminOmbor_sold_weekly_avg: 'Average weekly sales',
    adminOmbor_sold_monthly_avg: 'Average monthly sales',
    adminOmbor_total_revenue: 'Total revenue',
    adminOmbor_total_cost: 'Cost price',
    adminOmbor_net_profit: 'Net profit',
    adminOmbor_filter_all_branches: 'All branches',
    adminOmbor_sales_by_day: 'Monthly sales (by day)',
    adminOmbor_chart_no_data: 'No data for this month',
    adminOmbor_chart_legend: 'Days 1–31, bar — quantity sold',
    adminOmbor_search_inv_placeholder: 'Search by name, price, barcode',
    adminOmbor_kpi_product_types: 'Total product types',
    adminOmbor_kpi_expiry_critical: 'Expires in less than 3 days',
    adminOmbor_kpi_expiry_hint: 'Tap to filter / tap again to clear',
    adminOmbor_expiry_date: 'Expiry date',
    adminOmbor_expiry_days_left: 'days left',
    adminOmbor_expiry_passed: 'Expired',
    adminOmbor_select_branch_for_table: 'Select a branch to view the table',
    product_sale_price_per_unit_hint: 'Price per 1 kg or 1 m',
    adminOmbor_open_measures_to_fill: 'Before saving, open the units section via «+ Add» and enter the primary stock and prices.',
    adminOmbor_sale_lines_required: 'Add at least one additional unit or variant (with price), or enable «Free price».',
    adminOmbor_add_variant_row: 'Add variant',
    adminOmbor_nested_lines_title: 'Additional sale',
    adminOmbor_all_units_used: 'All units are already added. Change the unit in an existing card or remove the extra one.',
    adminOmbor_barcode_missing: 'Barcode is missing',
    adminOmbor_kpi_expiry_clear: 'Clear filter',
    adminOmbor_kpi_expiry_filter: 'Filter',
    adminOmbor_kpi_expiry_active: '✓ Filter active — tap to clear',
    adminOmbor_variant_select: 'Select variant',
    adminOmbor_product_id_missing: 'Product identifier not found. Refresh the row and try again.',
    adminOmbor_variant_required: 'Variant selection is required.',
    adminOmbor_sale_price_required_on_edit: 'Primary unit sale price must be greater than 0.',
    adminOmbor_measure_card_title_primary: 'Primary unit',
    adminOmbor_tenant_ownerlar: 'Clients (owners)',
    adminInventoryAudit_title: 'Inventory audit',
    adminExpiryTracking_title: 'Expiry tracking',
    common_cancel: 'Cancel',
    common_close: 'Close',
    common_edit: 'Edit',
    common_delete: 'Delete',
    common_save_error: 'Error saving',
    adminLoading: 'Loading…',
    navHome: 'Home',
    loginModalPasswordHide: 'Hide password',
    loginModalPasswordShow: 'Show password',
    roleSwitch_enter_cashier_pin: 'Enter cashier PIN',
    adminOrder_convert_region_manager_required: 'Select region and regional manager.',
    adminOrder_subtitle_ega: 'List of all orders. Track by client, manager, dispatcher and status.',
    adminNotif_subtitle_tenant_owner: 'Chat and system notifications. Support replies also appear here.',
    adminStat_filter_all_regions: 'All regions',
    adminStat_netProfitMonth: 'Net profit (month)',
    adminStat_platform_overview: 'Platform overview',
    adminStat_digitalRevenue: 'Click / Payme',
    adminStat_analyst_overview: 'Analytics overview',
    adminStat_analyst_visitors: 'Visitors',
    adminStat_analyst_sessions: 'Sessions',
    adminStat_analyst_top_channel: 'Top channel',
    adminStat_analyst_new_customers: 'New customers',
    adminStat_analyst_avg_session: 'Avg. session',
    adminStat_analyst_bounce: 'Bounce rate',
    adminStat_chartTitle_analyst: 'Weekly visitors',
    adminCredits_repay_total_invalid: 'Total repayment must not exceed the remaining balance.',
    adminCredits_manual_add: 'Add manual credit',
    adminCredits_manual_hint:
      'Search retail client by name or phone. If not found, a new client will be created.',
    adminCredits_manual_amount: 'Credit amount (UZS)',
    adminCredits_manual_note: 'Note (optional)',
    adminCredits_manual_client_required: 'Enter name and phone',
    adminCredits_manual_amount_required: 'Amount must be greater than 0',
    adminCredits_manual_phone_invalid:
      'Invalid phone number. Example: 90 123 45 67 or +998 90 123 45 67',
    retailClients_name: 'Name',
    retailClients_phone: 'Phone',
    adminPL_expense_product_volume_note: 'Product volume (optional)',
    adminPL_units_short: 'units',
    adminSettings_printer_app: 'Printer app',
    cashierKassa_quick_units: 'Quick sale units',
    cashierKassa_cart_line_unit: 'Unit',
    adminOmbor_bulk_intake_product_search: 'Name, barcode, or ID',
    adminOmbor_bulk_intake_product_no_results: 'No products match your search',
    cashierKassa_free_price_required: 'Enter a price greater than 0 for free pricing.',
    cashierKassa_out_of_stock: '“{name}” — out of stock.',
    cashierKassa_branch_mix_forbidden: 'You cannot mix products from different branches in one cart.',
    cashierKassa_test_receipt_success: 'Test receipt sent successfully.',
    appNotice_confirm: 'Got it',
    common_ok: 'OK',
    adminPosAccess_error_plan: 'POS cabinet access is not available on your current plan. Upgrade from 299,000 UZS.',
    adminPosAccess_error_limit: 'POS access limit for your plan has been reached.',
    cashierKassa_cart_open_sheet: 'Edit all lines',
    cashierKassa_cart_sheet_title: 'Edit cart',
    cashierKassa_cart_sheet_hint: 'Open each line to change quantity and price',
    cashierKassa_choose_variant_only: 'Select variant',
    printer_status_connected: 'Printer: {name}',
    printer_status_not_connected: 'Printer: not connected',
    printer_status_desktop_unavailable: 'Printer: desktop mode unavailable',
    barcode_printer_status_connected: 'Barcode: {name}',
    barcode_printer_status_not_connected: 'Barcode: not connected',
    barcode_printer_status_desktop_unavailable: 'Barcode: desktop mode unavailable',
    printer_settings_title: 'Printer settings',
    printer_receipt_label: 'Receipt printer',
    printer_barcode_label: 'Barcode printer',
    printer_auto_select: 'Auto select',
    printers_detected: '{count} printers detected',
    printer_status_fetch_error: 'Could not fetch printer status',
    adminBarcodeScan_title: 'Barcode scanner',
    adminBarcodeScan_hint: 'Hold the barcode inside the frame',
    adminBarcodeScan_container_missing: 'Scanner container not found',
    adminBarcodeScan_camera_error: 'Error opening camera',
    printer_app_title: 'Printer app',
    printer_app_desc: 'Download the local printer app for receipts. Install and configure once.',
    printer_app_download: 'Download printer app',
    printer_app_download_error: 'Download error',
    printer_app_hint: 'LocalPrintingBridge.exe — install the app and configure the printer. Receipts will print automatically.',
    qz_settings_title: 'QZ Tray — printer settings',
    qz_connected: 'Connected',
    qz_disconnected: 'Not connected',
    qz_connect: 'Connect to QZ Tray',
    qz_disconnect: 'Disconnect',
    qz_select_printer: 'Select printer',
    qz_select_placeholder: '— Select printer —',
    qz_test_print: 'Print (test receipt)',
    qz_connect_error: 'Connection error',
    qz_select_first: 'Select a printer first',
    qz_test_success: 'Test receipt printed successfully!',
    qz_print_error: 'Print error',
    qz_hint: 'QZ Tray must be running on your computer. Download from qz.io. The selected printer is remembered for the next session.',
    cashierProducts_stock_in_title: 'Add to warehouse',
    cashierProducts_fav_add: 'Add to favorites',
    cashierProducts_fav_remove: 'Remove from favorites',
    cashierProducts_stock_in_product: 'Product',
    cashierProducts_stock_in_cost: 'Cost price',
    cashierProducts_stock_in_measure: 'Unit',
    adminMarketing_close: 'Close',
    adminMarketing_dismiss_notice: 'Dismiss notification',
    adminMarketing_dismiss_error: 'Dismiss error',
    adminMarketing_orders_loading: 'Loading…',
    adminMarketing_orders_empty_day: 'No online orders found for the selected day.',
    adminMarketing_branches_label: 'Branches',
    adminMarketing_orders_hint_owner: 'Daily list (selected date). Backend should use a single source so status stays in sync with Telegram and here.',
    adminOmbor_barcode_print_failed: 'Failed to print barcode',
    adminOmbor_desktop_printer_api_missing: 'Desktop printer API not found. Restart the app and check printer selection.',
    adminMarketing_owner_lead: 'Marketing: online shop (short /{path}/… link), orders, and Telegram.',
    adminMarketing_shop_url_label: 'Online shop URL',
    adminMarketing_shop_hint_local: 'Local testing: link uses the current origin. In production set REACT_APP_SHOP_ROOT_DOMAIN=adde.app — the card will show that domain.',
    adminMarketing_shop_qr_alt: '{name} shop QR',
    adminMarketing_delivery: 'Delivery',
    adminMarketing_delivery_on: 'Enabled',
    adminMarketing_delivery_off: 'Disabled',
    adminMarketing_tg_group: 'Group',
    adminMarketing_telegram_group: 'Telegram group',
    adminMarketing_linked: 'Linked',
    adminMarketing_unlinked: 'Not linked',
    adminMarketing_copy_url: 'Copy link',
    adminMarketing_configure: 'Configure',
    adminMarketing_orders_title_owner: 'Online orders',
    adminMarketing_filter_date: 'Date',
    adminMarketing_filter_branch: 'Branch',
    adminMarketing_all_branches: 'All branches',
    adminMarketing_status_new: 'New',
    adminMarketing_status_confirmed: 'Confirmed',
    adminMarketing_status_cancelled: 'Rejected',
    adminMarketing_total_sales: 'Total sales',
    adminMarketing_net_profit: 'Net profit',
    adminMarketing_address: 'Address',
    adminMarketing_region: 'Region',
    adminMarketing_saving: 'Saving…',
    adminMarketing_btn_confirm: 'Confirm',
    adminMarketing_btn_reject: 'Reject',
    adminMarketing_settings_title: 'Branch marketing settings',
    adminMarketing_subdomain_optional: 'Shop subdomain (optional)',
    adminMarketing_subdomain_path_optional: 'Short shop link name (optional, /{path}/…)',
    adminMarketing_subdomain_ph: 'e.g. dilshod-market',
    adminMarketing_subdomain_path_ph: 'e.g. chust (empty — id or slug)',
    adminMarketing_subdomain_invalid: 'Lowercase letters, digits, and hyphens only; no leading or trailing hyphen.',
    adminMarketing_toggle_delivery: 'Enable/disable delivery',
    adminMarketing_tg_connect: 'Link Telegram group',
    adminMarketing_tg_connect_hint: 'Tap to open Telegram, pick a group, and the bot joins. No need to pick the bot or open chat separately. Link updates on the server after webhook.',
    adminMarketing_tg_qr_scan: 'Or scan the QR code with your phone camera',
    adminMarketing_tg_qr_alt: 'Add to Telegram group',
    adminMarketing_status: 'Status',
    adminMarketing_tg_linked_status: 'Linked — {title}',
    adminMarketing_tg_pending_status: 'Pending (updates after the bot joins the group)',
    adminMarketing_group_fallback: 'group',
    adminMarketing_save: 'Save',
    adminMarketing_save_failed: 'Could not save',
    adminMarketing_order_status_failed: 'Could not update order status. Please try again.',
    adminMarketing_new_orders_count: '{count} new online order(s) received ({time}).',
    adminMarketing_new_order_single: 'New online order: #{number}',
    adminMarketing_payment_cash: 'Cash',
    adminMarketing_payment_card: 'Card',
    adminMarketing_payment_transfer: 'Bank transfer',
    branchShop_total: 'Total',
    branchShop_client_name: 'Customer name',
    branchShop_client_name_ph: 'Name',
    branchShop_phone: 'Phone',
    branchShop_phone_aria: 'Mobile number, 9 digits',
    branchShop_delivery_method: 'Pickup method',
    branchShop_pickup: 'Pickup',
    branchShop_delivery: 'Delivery',
    branchShop_region: 'Region',
    branchShop_region_select: 'Select region',
    branchShop_district: 'District',
    branchShop_district_select_first: 'Select a region first',
    branchShop_district_select: 'Select district',
    branchShop_address: 'Address',
    branchShop_address_ph: 'Delivery address',
    branchShop_verify_code_title: 'Verification code',
    branchShop_verify_code_desc: 'This code is also in your SMS (test / dev response).',
    branchShop_test_badge: 'Test',
    branchShop_copied: 'Copied',
    branchShop_copy_code: 'Copy',
    branchShop_sms_code: 'SMS code',
    branchShop_resend_in: 'Resend in',
    branchShop_sms_sending: 'Sending SMS…',
    branchShop_verify_phone: 'Verify number',
    branchShop_submitting: 'Submitting…',
    branchShop_send_sms: 'Send SMS',
    branchShop_place_order: 'Place order',
    branchShop_phone_verified: '✓ Phone verified. You can submit the order.',
    branchShop_default_title: 'Branch shop',
    branchShop_subtitle: 'Online order — pick products and submit.',
    branchShop_cart_aria: 'Cart',
    branchShop_loading: 'Loading…',
    branchShop_search_label: 'Search products',
    branchShop_search_ph: 'Name, marking, marketing title, keywords…',
    branchShop_no_products: 'No products yet.',
    branchShop_no_search_results: 'No products match your search.',
    branchShop_no_image: 'No image',
    branchShop_add_to_cart: 'Add to cart',
    branchShop_cart_title: 'Cart',
    branchShop_cart_empty: 'Empty for now.',
    branchShop_qty_aria: 'Quantity',
    branchShop_qty_max: 'Max {n}',
    branchShop_remove_from_cart: 'Remove from cart',
    branchShop_close: 'Close',
    branchShop_variant_hint: 'Choose size or variant',
    branchShop_unit_factor_hint: '{n} pcs inside',
    branchShop_variant_default: 'Variant',
    branchShop_sms_not_sent: 'Send SMS first.',
    branchShop_verify_failed: 'Verification failed.',
    branchShop_code_verify_failed: 'Code not verified.',
    branchShop_sms_not_verified_submit: 'SMS not verified.',
    branchShop_branch_unknown: 'Branch not found. Refresh the page and try again.',
    branchShop_cart_invalid: 'Cart is empty or quantities are invalid.',
    branchShop_order_success: 'Order received. Stock decreases when the cashier/Telegram confirms it. We will contact you soon.',
    branchShop_insufficient_stock: 'Insufficient stock. Reduce quantities or refresh the page.',
    branchShop_order_failed: 'Order could not be sent. Please try again.',
    branchShop_sms_failed: 'SMS could not be sent.',
    branchShop_branch_default: 'Branch',
    branchShop_err_phone_invalid: 'Invalid phone number.',
    branchShop_err_sms_code_invalid: 'Invalid SMS code.',
    branchShop_err_sms_code_expired: 'SMS code expired, send again.',
    branchShop_err_sms_not_verified: 'Phone not verified yet.',
    branchShop_err_verification_not_found: 'Verification session not found, send SMS again.',
    branchShop_err_branch_id_invalid: 'Branch ID not found. Refresh or use the correct shop link.',
  },
};
